import { render, staticRenderFns } from "./infoViewDialog.vue?vue&type=template&id=64a3b387&scoped=true&"
import script from "./infoViewDialog.vue?vue&type=script&lang=js&"
export * from "./infoViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./infoViewDialog.vue?vue&type=style&index=0&id=64a3b387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3b387",
  null
  
)

export default component.exports